import { Instagram, Linkedin, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/socials";
import { trackEvent } from "@/lib/tracking";

const TikTokIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.9 2.9 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
);

const ICONS = {
    instagram: Instagram,
    tiktok: TikTokIcon,
    linkedin: Linkedin,
    youtube: Youtube,
};

const isValidUrl = (url) => typeof url === "string" && /^https:\/\/.+/.test(url);

export default function SocialLinks({ showHandles = true }) {
    const active = SOCIALS.filter((social) => isValidUrl(social.url));
    if (active.length === 0) return null;

    return (
        <ul className="flex flex-wrap items-center gap-3" data-testid="social-links-list">
            {active.map((social) => {
                const Icon = ICONS[social.id];
                return (
                    <li key={social.id}>
                        <a
                            href={social.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Acessar o ${social.label} da Contabeleza`}
                            data-testid={`link-social-${social.id}`}
                            onClick={() =>
                                trackEvent("social_click", { network: social.id, location: "footer" })
                            }
                            className="inline-flex h-11 items-center gap-2.5 rounded-full border border-[#B2D0FF]/25 px-4 text-sm font-medium text-[#B2D0FF] transition-all duration-200 hover:border-[#B2D0FF] hover:bg-white/10 hover:text-white active:scale-[0.97]"
                        >
                            <Icon className="h-5 w-5" strokeWidth={1.75} />
                            {showHandles && social.handle ? <span>{social.handle}</span> : null}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
